import type { ComponentType, ReactNode } from 'react';
import type { HtmlTagName, ComponentOrHtmlProps } from 'utils/types';
import styles from './Grid.module.scss';
import Row from './Row';
import Col from './Col';
import classNames from 'classnames';

type Props<T> = {
  tag?: T;
  className?: string;
  content?: ReactNode;
  children?: ReactNode;
} & ComponentOrHtmlProps<T>;

const stylesDic = styles as Record<string, string | undefined>;

function HeadingRow<T extends HtmlTagName = 'h2'>(props: Props<T>): React.JSX.Element;
function HeadingRow<T extends ComponentType<any>>(props: Props<T>): React.JSX.Element;
function HeadingRow({ tag: Tag = 'h2', className, content, children, ...props }: Props<any>) {
  return (
    <Row className={classNames(styles.heading, stylesDic[Tag], className)} {...props}>
      <Col className={styles.alignSelfCenter}>
        <Tag>{content}</Tag>
      </Col>
      {children && <Col size="auto" className={styles.alignSelfCenter}>{children}</Col>}
    </Row>
  );
}

export default HeadingRow;
